import React, { lazy, Suspense } from 'react';
import { Route, Routes, Navigate, useParams } from 'react-router-dom';
import Layout from './sections/layout';
import Home from './pages/Home';
import Ideas from './pages/Ideas';

// The voice SDK and archived pages stay out of the main reading experience.
const Demo = lazy(() => import('./pages/Demo'));
const Work = lazy(() => import('./pages/Work'));
const ProjectDetail = lazy(() => import('./pages/ProjectDetail'));
const Experiments = lazy(() => import('./pages/Experiments'));
const Writing = lazy(() => import('./pages/Writing'));
const PostReader = lazy(() => import('./pages/PostReader'));

function SlugRedirect({ to }) {
  const { slug } = useParams();
  return <Navigate to={`${to}/${slug}`} replace />;
}

export default function App() {
  return (
    <Layout>
      <Suspense fallback={<div className="reading-page" role="status">Loading…</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ideas" element={<Ideas />} />
          <Route path="/experiments" element={<Experiments />} />
          <Route path="/experiments/ai-keyan" element={<Demo />} />
          <Route path="/demo" element={<Navigate to="/experiments/ai-keyan" replace />} />
          <Route path="/contact" element={<Navigate to="/#contact" replace />} />
          <Route path="/projects" element={<Work />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="/writing/:slug" element={<PostReader />} />
          <Route path="/about" element={<Navigate to="/" replace />} />
          <Route path="/now" element={<Navigate to="/" replace />} />
          <Route path="/work" element={<Navigate to="/projects" replace />} />
          <Route path="/work/:slug" element={<SlugRedirect to="/projects" />} />
          <Route path="/posts" element={<Navigate to="/writing" replace />} />
          <Route path="/blog" element={<Navigate to="/writing" replace />} />
          <Route path="/posts/:slug" element={<SlugRedirect to="/writing" />} />
          <Route path="/blog/:slug" element={<SlugRedirect to="/writing" />} />
          <Route path="/creations" element={<Navigate to="/projects" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}
